import VoucherGroupTable from './VoucherGroupTable';

export default VoucherGroupTable;


// WEBPACK FOOTER //
// ./src/scenes/VoucherGroups/index.ts